import { memo } from 'react';

type HighlightMatchProps = {
    text: string;
    query: string;
    className?: string;
};

// Escapes regex metacharacters so a query typed by a user is matched as literal text —
// client display names are composed as `First (Preferred) Last`, so parentheses are real data.
function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const HighlightMatch = memo(function HighlightMatch({ text, query }: HighlightMatchProps) {
    if (!query.trim()) return <>{text}</>;

    const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi');
    const parts = text.split(regex);

    return (
        <>
            {parts.map((part, index) => {
                if (regex.test(part)) {
                    regex.lastIndex = 0;
                    return (
                        <span key={index} className="text-secondary font-bold">
                            {part}
                        </span>
                    );
                }
                return part;
            })}
        </>
    );
});
